import React, { useRef } from 'react';

type OptionMore = {
  childMarginLeft?: string;
};

interface Props {
  dataTree: any[];
  renderTreeItem: any;
  isChildItem?: boolean;
  levelRender?: number;
  startLevel?: number;
  parentId?: number | string;
  fieldChildArray?: string;
  showHideChildren?: boolean;
  option?: OptionMore;
}

export default function Tree({
  parentId,
  dataTree,
  renderTreeItem,
  isChildItem,
  levelRender,
  startLevel,
  fieldChildArray = 'children',
  showHideChildren = true,
  option,
}: Props) {
  const rootElementComponent = useRef(null);

  const toggleChildren = function (item: any) {
    if (
      showHideChildren &&
      item &&
      item[fieldChildArray] &&
      item[fieldChildArray].length > 0 &&
      rootElementComponent &&
      rootElementComponent.current
    ) {
      const rootElement = rootElementComponent.current as HTMLElement;
      const listChildrenElement = rootElement.querySelector(`.parent-node-${item.id}`);
      listChildrenElement?.classList.contains('hidden')
        ? listChildrenElement?.classList.remove('hidden')
        : listChildrenElement?.classList.add('hidden');
    }
  };

  return (
    <>
      {(!startLevel && !levelRender) || (startLevel && levelRender && startLevel <= levelRender) ? (
        <ul
          className={
            `parent-node-${parentId} ` +
            (isChildItem ? (option?.childMarginLeft ? option?.childMarginLeft : 'ml-3') : '')
          }
          ref={rootElementComponent}
        >
          {dataTree.map((item) => {
            return (
              <React.Fragment key={item.id}>
                {item.isShow === false ? null : (
                  <li className="mt-2">
                    <div onClick={() => toggleChildren(item)} className="cursor-pointer">
                      {renderTreeItem(item)}
                    </div>
                    {item[fieldChildArray] && item[fieldChildArray].length > 0 ? (
                      <Tree
                        parentId={item.id}
                        dataTree={item[fieldChildArray]}
                        renderTreeItem={renderTreeItem}
                        isChildItem={true}
                        startLevel={startLevel ? startLevel + 1 : 0}
                        levelRender={levelRender}
                        option={option}
                        fieldChildArray={fieldChildArray}
                        showHideChildren={showHideChildren}
                      />
                    ) : null}
                  </li>
                )}
              </React.Fragment>
            );
          })}
        </ul>
      ) : null}
    </>
  );
}
